module.exports = __webpack_public_path__ + "img/draw_noright.5705858b.png";